module.exports = __webpack_public_path__ + "assets/star.934fb0a9.svg";